module.exports = __webpack_public_path__ + "media/inkling.9fa5f2e6.wav";